import React from 'react';
import { motion } from 'framer-motion';
import { Briefcase, UserCheck, Building2, Rocket } from 'lucide-react';
const services = [{
  icon: Briefcase,
  title: 'C-Suite Search',
  description: 'Identifying and securing transformative leadership for CEO, COO, CFO, and CTO roles.'
}, {
  icon: UserCheck,
  title: 'VP-Level Recruitment',
  description: 'Building strong management layers with experienced Vice Presidents across all functions.'
}, {
  icon: Building2,
  title: 'Board Advisory',
  description: 'Connecting companies with independent board members who bring strategic value and governance.'
}, {
  icon: Rocket,
  title: 'Startup Leadership',
  description: 'Specialized recruitment for Seed and Series A companies needing their first key hires.'
}];
interface ServicesProps {
  onNavigate?: (page: string) => void;
}
export function Services({
  onNavigate
}: ServicesProps) {
  return <section className="py-24 bg-gray-50" id="services" data-id="element-83">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-84">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16" data-id="element-85">
          <div data-id="element-86">
            <motion.h2 initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="text-3xl md:text-4xl font-bold text-gray-900 uppercase tracking-widest mb-4" data-id="element-87">
              Our Expertise
            </motion.h2>
            <div className="w-24 h-1 bg-primary" data-id="element-88"></div>
          </div>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} className="text-gray-600 max-w-xl mt-6 md:mt-0 text-lg" data-id="element-89">
            We specialize in finding the perfect match for high-stakes roles
            where leadership capability defines company success.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-90">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} onClick={() => onNavigate?.('services')} className="bg-white p-8 shadow-sm hover:shadow-xl transition-all duration-300 border-t-4 border-transparent hover:border-primary group cursor-pointer" data-id="element-91">
              <service.icon className="w-12 h-12 text-gray-400 group-hover:text-primary transition-colors duration-300 mb-6" strokeWidth={1.5} data-id="element-92" />
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-93">
                {service.title}
              </h3>
              <p className="text-gray-600" data-id="element-94">{service.description}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}